import api from "app/lib/api";
import endpoints from "static/endpoints";
import { interpolate } from "utils/string";

/**
 * Fetches the list of live call tasks from the API.
 * @async
 * @function
 * @returns {Promise<any>} A promise that resolves to the data containing live call tasks.
 */
export const getLiveCallTasks = async (query = {}) => {
  const {
    page,
    pageSize,
    search,
    account,
    advisory,
    monthlyBatteryCheck,
    sort,
  } = query;

  const params = new URLSearchParams();

  if (page) params.append("page", page);
  if (pageSize) params.append("pageSize", pageSize);
  if (search) params.append("search", search);
  if (account && account !== "all") params.append("account", account);
  if (advisory && advisory !== "all") params.append("advisory", advisory);
  if (monthlyBatteryCheck && monthlyBatteryCheck !== "all")
    params.append("monthlyBatteryCheck", monthlyBatteryCheck);
  if (sort) params.append("sort", sort);

  const queryString = params.toString();

  const url = queryString
    ? `${endpoints.liveCallTasks.getLiveCallTasks}?${queryString}`
    : endpoints.liveCallTasks.getLiveCallTasks;

  const result = await api.get(url);
  return result.data;
};

/**
 * Marks a live call task as manually completed, recording a reason.
 * @async
 * @function
 * @param {{taskId: string, reason: string, completionDate: any}} payload
 * @returns {Promise<any>} A promise that resolves to the updated task.
 */
export const markTaskComplete = async ({ taskId, reason, completionDate }) => {
  const url = interpolate(endpoints.liveCallTasks.markComplete, { taskId });
  const { data } = await api.put(url, { reason, completionDate });
  return data;
};
